import http from "./httpService";

const apiEndPoint = "/depthoffields/";

function getDepthOfFields() {
  return http.get(apiEndPoint);
}

export default getDepthOfFields;
